import { styled } from '@material-ui/core';

export const HIWPageWrapper = styled('div')({
	minHeight: '100vh',
	padding: '50px 0',
	backgroundColor: 'var(--color-bg-primary)',
});
export const HIWPageContent = styled('div')({
	maxWidth: '1200px',
	width: '90%',
	margin: '0 auto',
	display: 'flex',
	flexDirection: 'column',
	gap: 40,
});
export const HIWHero = styled('div')({
	'display': 'flex',
	'padding': '40px',
	'border': '1px solid var(--color-border-default)',
	'borderRadius': '5px',
	'backgroundColor': 'var(--color-bg-elevated)',

	'& .left': {
		flexBasis: '50%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		gap: '20',
	},

	'& .right': {
		'flexBasis': '50%',
		'display': 'flex',
		'flexDirection': 'column',

		'& img': {
			height: '300px',
			objectFit: 'contain',
		},
	},

	'& h1': {
		fontFamily: 'var(--font-family-bold)',
		fontSize: 'var(--text-h1-size)',
		lineHeight: 'var(--leading-tight)',
		marginBottom: '20px',
		color: 'var(--color-text-primary)',
	},
	'& p': {
		fontFamily: 'var(--font-family-light)',
		marginBottom: '45px',
		color: 'var(--color-text-secondary)',
		maxWidth: '520px',
		fontSize: 'var(--type-md)',
		lineHeight: 'var(--leading-relaxed)',
	},

	'& .cta': {
		display: 'flex',
		alignItems: 'center',
		gap: 20,
	},

	'& button': {
		width: 'max-content',
	},

	'& .outline': {
		background: 'var(--color-bg-elevated)',
		color: 'var(--color-text-secondary)',
		border: '1px solid var(--color-border-default)',
		fontWeight: 300,
		letterSpacing: 'normal',
	},
});

export const ElectionAgentPartySelection = styled('div')({
	'display': 'flex',
	'flexDirection': 'column',
	'gap': '20',
	'paddingTop': '30px',

	'& h4': {
		fontFamily: 'var(--font-family-semibold)',
		fontSize: 'var(--text-h5-size)',
		lineHeight: 'var(--leading-snug)',
		color: 'var(--color-brand-primary-dark)',
		marginBottom: '15px',
		textAlign: 'center',
	},
	'& .description': {
		fontFamily: 'var(--font-family-regular)',
		fontSize: 'var(--text-body-sm-size)',
		lineHeight: 'var(--leading-normal)',
		color: 'var(--color-text-secondary)',
		marginBottom: '40px',
		textAlign: 'center',
	},

	'& .content': {
		borderRadius: '5px',
		display: 'grid',
		gridRow: 'auto',
		gap: '20px',
		gridTemplateColumns: 'repeat(auto-fill, minmax(40%, 1fr))',
	},
});

export const PartyCard = styled('div')({
	'width': '100%',
	'border': '1px solid var(--color-border-default)',
	'borderRadius': '5px',
	'display': 'flex',
	'flexDirection': 'column',
	'padding': '15px',
	'cursor': 'pointer',
	'backgroundColor': 'var(--color-bg-elevated)',
	'transition': 'var(--transition-normal)',
	'&:hover': {
		borderColor: 'var(--color-brand-primary)',
		boxShadow: 'var(--shadow-sm)',
	},

	'& h5': {
		fontFamily: 'var(--font-family-medium)',
		fontSize: 'var(--text-body-size)',
		lineHeight: 'var(--leading-snug)',
		margin: '0 0 7px',
		color: 'var(--color-text-primary)',
	},
	'& p': {
		fontFamily: 'var(--font-family-regular)',
		fontSize: 'var(--text-caption-size)',
		lineHeight: 'var(--leading-normal)',
		margin: '0',
		color: 'var(--color-text-tertiary)',
		textDecoration: 'underline',
	},
});
